// extracted by mini-css-extract-plugin
module.exports = {"link":"NavigationLink_link__13OH5","linkLight":"NavigationLink_linkLight__1LP7n","linkDark":"NavigationLink_linkDark__3ivfN"};